import { AppComponent } from './app';
import { HomeComponent } from './home';
import { MigrationRunner } from './migrations-runner';
import { PublicHostComponent } from './public-host';
import { PlaylistViewer } from './playlist-viewer';

export const containers: any[] = [
  AppComponent,
  HomeComponent,
  MigrationRunner,
  PublicHostComponent,
  PlaylistViewer
];

export * from './app';
export * from './home';
export * from './migrations-runner';
export * from './public-host';
export * from './playlist-viewer';
